import * as React from "react"

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={24} {...props}>
    <defs>
      <style>{".cls-1{fill:#00446e}"}</style>
    </defs>
    <g id="noun-users-2120769" transform="translate(-.001 -150)">
      <path
        id="Path_197"
        data-name="Path 197"
        className="cls-1"
        d="M758 254a4 4 0 1 1-4-4 4 4 0 0 1 4 4"
        transform="translate(-729.999 -97.333)"
      />
      <path
        id="Path_198"
        data-name="Path 198"
        className="cls-1"
        d="M703.815 625h-.667a7.306 7.306 0 0 0-5.393 2.367 10.636 10.636 0 0 1 2.06 6.3v.667h11.333v-2a7.329 7.329 0 0 0-7.333-7.334z"
        transform="translate(-679.147 -462.333)"
      />
      <path
        id="Path_199"
        data-name="Path 199"
        className="cls-1"
        d="M160.667 155.333a5.333 5.333 0 1 1-5.334-5.333 5.333 5.333 0 0 1 5.333 5.333"
        transform="translate(-145.999)"
      />
      <path
        id="Path_200"
        data-name="Path 200"
        className="cls-1"
        d="M10 625H8.668A8.666 8.666 0 0 0 0 633.663v2.667h18.668v-2.667A8.67 8.67 0 0 0 10 625z"
        transform="translate(0 -462.329)"
      />
    </g>
  </svg>
)

export default SvgComponent